export const HappyCustomers = '5'
export const HappyCustomerRatings = '45,000'
export const TrustPilotRating = '5'
